import React, { useRef, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX, FiUserPlus } from "react-icons/fi";

export default function AddCandidateModal({ show, onHide }) {
  const fileRef = useRef();
  const [image, setImage] = useState(null);

  const handleUploadClick = () => {
    fileRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      {/* HEADER */}
      <div style={header}>
        <h5 style={{ fontWeight: 600 }}>Add New Candidate</h5>
        <div onClick={onHide} style={closeBtn}>
          <FiX />
        </div>
      </div>

      <Modal.Body>
        {/* IMAGE UPLOAD */}
        <div style={uploadBox}>
          <div style={avatarBox}>
            {image ? (
              <img src={image} style={{ width: "100%", borderRadius: "50%" }} />
            ) : (
              <FiUserPlus size={22} />
            )}
          </div>

          <div>
            <h6>Upload Profile Image</h6>
            <p style={{ fontSize: 12, color: "#6b7280" }}>
              Image should be below 4 mb
            </p>

            <div style={{ display: "flex", gap: 10 }}>
              <Button style={btnOrange} onClick={handleUploadClick}>
                Upload
              </Button>

              <Button
                style={{
                  background: "#eee",
                  border: "none",
                  color: "#333",
                }}
                onClick={() => setImage(null)}
              >
                Cancel
              </Button>
            </div>

            <input
              type="file"
              ref={fileRef}
              hidden
              onChange={handleFileChange}
              accept="image/*"
            />
          </div>
        </div>

        {/* FORM */}
        <div style={{ display: "flex", gap: 15, flexWrap: "wrap" }}>
          {[
            { label: "Name *" },
            { label: "Email Address" },
            { label: "Branch" },
            { label: "Graduation Year *" },
            { label: "Job Role" },
            { label: "Recruiter Name" },
          ].map((f, i) => (
            <div key={i} style={{ flex: "1 1 48%" }}>
              <Form.Label>{f.label}</Form.Label>
              <Form.Control style={inputStyle} />
            </div>
          ))}
        </div>
      </Modal.Body>

      {/* FOOTER */}
      <div style={footer}>
        <Button style={btnGrey} onClick={onHide}>
          Cancel
        </Button>

        <Button style={btnOrange}>
          Add Candidate
        </Button>
      </div>
    </Modal>
  );
}

/* STYLES */

const header = {
  display: "flex",
  justifyContent: "space-between",
  padding: 15,
  borderBottom: "1px solid #eee",
};

const closeBtn = {
  cursor: "pointer",
  background: "#f3f4f6",
  borderRadius: "50%",
  padding: 6,
};

const uploadBox = {
  display: "flex",
  gap: 20,
  alignItems: "center",
  background: "#f9fafb",
  padding: 15,
  borderRadius: 10,
  marginBottom: 20,
};

const avatarBox = {
  width: 70,
  height: 70,
  borderRadius: "50%",
  background: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #ddd",
};

const inputStyle = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 6,
  padding: "8px",
};

const footer = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  padding: 15,
  borderTop: "1px solid #eee",
};

const btnOrange = {
  background: "#f97316",
  border: "none",
};

const btnGrey = {
  background: "#eee",
  border: "none",
  color: "#333",
};